import { Card, CardContent, CardHeader, CardTitle } from "@motley/design"

type Props = {
  heading: string
  body: string
  spark: "orange" | "purple" | "yellow"
}

export default function StepCard({ heading, body, spark }: Props) {
  return (
    <Card spark={{ colour: spark }}>
      <CardHeader>
        <CardTitle className="font-title text-xl font-medium tracking-tight sm:text-[1.3rem]">
          {heading}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="mt-2 text-sm leading-relaxed text-muted-foreground sm:text-[0.88rem]">
          {body}
        </p>
      </CardContent>
    </Card>
  )
}
